import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
// import AlertBox from '../alertBox';
// import { unisportDiscount } from '../../discounts';

// const OptionsAlert = (props) => {
//   return <div>{props.msg}</div>;
// };

class Options extends Component {
  handleClick = () => {
    const hasShirt = this.props.customizations.some(el => el.products.some(p => p.type === 'tshirt'));
    if (hasShirt) {
      this.props.updateUnisportLogoCustomization(this.props.costumizationToggleItems);
      this.props.updateAlert('unisport');
    } else {
      this.props.updateAlert('unisport');
      this.props.toggleAlert();
    }
  }

  render() {
    return (
      <Fragment>
      <div className="option">
        <div className="optionItemHolder">
          <div className="optionItem">
            <div className="imageContainer">
              <div className="logo" />
            </div>
            <div className="textContainer">
              <div className="header">{this.props.customizationTranslations.GetDiscount}</div>
              <div className="subtitle">{this.props.customizationTranslations.AddUnisport}</div>
            </div>
            <div className="buttonContainer">
              <input
                id="cb1"
                className="tgl tgl-ios"
                type="checkbox"
                value={this.props.costumizationToggleItems.unisport ? 'on' : 'off'}
                onChange={() => this.handleClick()}
                checked={this.props.costumizationToggleItems.unisport}
              />
              <label className="tgl-btn" htmlFor="cb1" />
            </div>
          </div>
        </div>
      </div>

      {/* { (this.props.alertShown.isOpen && this.props.alerts !== 'leovegas') &&
        <AlertBox renderItem={OptionsAlert} toggleAlert={this.props.toggleAlert}
        msg={`For at kunne tilvælge de -${unisportDiscount},
        med Unisport som sponsor, skal der købes overdele til sættet.`}
        />
      } */}

      </Fragment>
    );
  }
}

const mapDispatch = dispatch => (
  {
    updateUnisportLogoCustomization: toggleItem => dispatch({
      type: 'UPDATE_UNISPORT_LOGO_CUSTOMIZATION',
      toggleItem,
    }),
    updateAlert: alertElement => dispatch({
      type: 'UPDATE',
      alertElement,
    }),
    toggleAlert: () => dispatch({
      type: 'TOGGLE',
    }),
  }
);

const mapState = state => (
  {
    costumizationToggleItems: state.costumizationToggleItems,
    customizationTranslations: state.customizationTranslations,
    customizations: state.customizations,
    alertShown: state.alertShown,
    ageConfirmed: state.ageConfirmed,
    isAdultProducts: state.isAdultProducts,
    alerts: state.alerts,
  }
);

export default connect(mapState, mapDispatch)(Options);
